"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _RatingDisplaySingleStar = _interopRequireDefault(require("angieslist-react-components/lib/RatingDisplaySingleStar"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _cookieUtils = require("angieslist-app-platform/lib/common/utils/cookieUtils");

var _icons = require("@angi/icons");

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

var _i, _hr, _hr2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var OfficeRightSideBar = function OfficeRightSideBar(_ref) {
  var numberOfBusinesses = _ref.numberOfBusinesses,
      logout = _ref.logout,
      proCity = _ref.proCity,
      proRegion = _ref.proRegion,
      proName = _ref.proName,
      rating = _ref.rating,
      reviewCount = _ref.reviewCount,
      displaySpId = _ref.displaySpId,
      userId = _ref.userId,
      isAngiLeads = _ref.isAngiLeads,
      isAdvertiser = _ref.isAdvertiser,
      isNorthStar = _ref.isNorthStar,
      isAgreementOnlineEnroll = _ref.isAgreementOnlineEnroll;
  var calendarBannerCookieKey = 'spid_of_calendar_banner_closed';

  var signOut = function signOut() {
    (0, _cookieUtils.deleteCookie)(calendarBannerCookieKey);
    logout(userId);
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--right-side-bar-div"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xsOffset: 1
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--right-nav-truncate unified-header--right-nav-name unified-header--right-nav-menu-top",
    id: "unified-header--flyout-menu-pro-name"
  }, proName), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--right-nav-truncate unified-header--right-nav-menu-top",
    id: "unified-header--flyout-menu-location"
  }, "".concat(proCity, ", ").concat(proRegion)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--right-nav-menu-top",
    id: "unified-header--flyout-menu-location"
  }, "ID: ".concat(displaySpId)), /*#__PURE__*/_react["default"].createElement("div", {
    id: "unified-header--flyout-menu-rating",
    className: "unified-header--right-nav-menu-top"
  }, /*#__PURE__*/_react["default"].createElement(_RatingDisplaySingleStar["default"], {
    rating: rating,
    ratingFontSize: "1.0em",
    starSize: "1.2em"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      marginLeft: 5,
      marginTop: 2
    }
  }, "(".concat(reviewCount, ")"))), /*#__PURE__*/_react["default"].createElement("div", {
    id: "unified-header--flyout-menu-edit-profile",
    className: "unified-header--right-nav-menu-switch-business"
  }, /*#__PURE__*/_react["default"].createElement(_icons.EditIcon, {
    contentProps: {
      fillColor: '#005F99'
    }
  }), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Edit profile",
    href: isAngiLeads ? _urlCatalog["default"].office.leads.businessSettings(displaySpId) : _urlCatalog["default"].office.ads.spProfile.edit(displaySpId),
    id: "unified-header--flyout-menu-edit-profile-link"
  }, "Edit profile"))), numberOfBusinesses > 1 && /*#__PURE__*/_react["default"].createElement("div", {
    id: "unified-header--flyout-menu-change-business",
    className: "unified-header--right-nav-menu-switch-business"
  }, _i || (_i = /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-arrow-toggle"
  })), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Switch business",
    href: _urlCatalog["default"].office.home(),
    id: "unified-header--flyout-menu-switch-business-link"
  }, "Switch business"))), _hr || (_hr = /*#__PURE__*/_react["default"].createElement("hr", {
    className: "unified-header--flyout-menu-divider"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--right-nav-menu-middle",
    id: "unified-header--flyout-menu-business-preferences"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "My preferences",
    href: _urlCatalog["default"].office.account.home(),
    id: "unified-header--flyout-menu-business-preferences-link"
  }, "Personal settings"))), !isAngiLeads && isAdvertiser && isNorthStar && isAgreementOnlineEnroll ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--right-nav-menu-middle",
    id: "unified-header--flyout-menu-premium-settings"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Angi Ads settings",
    href: _urlCatalog["default"].office.leads.agreementSettings(displaySpId),
    id: "unified-header--flyout-menu-premium-settings-link"
  }, "Angi Ads settings"))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    id: "unified-header--flyout-menu-business-help",
    className: "unified-header--right-nav-menu-middle"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Get help",
    href: _urlCatalog["default"].global.intercomAssistance(),
    id: "unified-header--flyout-menu-business-help-link"
  }, "Get help"))), /*#__PURE__*/_react["default"].createElement("div", {
    id: "unified-header--flyout-sign-out",
    className: "unified-header--right-nav-menu-middle"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Sign out",
    href: "/",
    id: "unified-header--flyout-menu-sign-out-link",
    onClick: signOut
  }, "Sign out"))), _hr2 || (_hr2 = /*#__PURE__*/_react["default"].createElement("hr", {
    className: "unified-header--flyout-menu-divider"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--right-nav-menu-middle"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Go to Angi.com",
    href: _urlCatalog["default"].drupalRoot,
    id: "unified-header--flyout-menu-angi-link"
  }, "Go to Angi.com")))))));
};

OfficeRightSideBar.defaultProps = {
  isAdvertiser: false,
  isNorthStar: false,
  isAgreementOnlineEnroll: true // TODO: BB-1795 will flip the default value to false

};

var _default = (0, _compose["default"])((0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
}), // eslint-disable-next-line no-unused-vars
(0, _reactRedux.connect)(function (state, props) {
  return {};
}, _objectSpread({}, _angieslistAppPlatform.analyticsActions)), _pure["default"])(OfficeRightSideBar);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/officeRightSideBar.js
// module id = 3586
// module chunks = 25